// Inbox, Erinnerungen und Anrufaufgaben (Runde 4, Agent 4A): crm/API.md, Abschnitte 7 und 19.4.
// Ergänzt `aufgabenApi` aus `index.ts`, ohne diese Datei anzufassen. Typen stehen hier, weil `types.ts` gemeinsam genutzt wird.
import { http } from "./client";
import type { Aufgabe, AufgabeEingabe, AufgabenZaehler, InboxAnsicht, Liste } from "./types";

const k = encodeURIComponent;

/** Reiter der Inbox: alle (Primary), calls (verpasst, Voicemail, angenommen ohne Lead), aufgaben (Follow-ups, Anrufaufgaben) */
export type InboxKategorie = "alle" | "calls" | "aufgaben";

/** Alle Reiter der Inbox: dazu Emails (Mail-Eingang, 6A) und Messages (SMS, 6D), die nicht aus Aufgaben bestehen */
export type InboxReiter = InboxKategorie | "emails" | "messages";

export interface ReiterZaehler extends AufgabenZaehler {
  /** fällige Einträge im Reiter Calls */
  calls: number;
  /** fällige Einträge im Reiter Aufgaben */
  aufgaben: number;
}

export interface InboxParameter {
  view?: InboxAnsicht;
  /** "me" (Standard), "all" oder user_… */
  assigned_to?: string;
  kategorie?: InboxKategorie;
  limit?: number;
  cursor?: string | null;
}

/** Ergebnis je Aufgabe bei `POST /api/tasks/mehrere` */
export interface MehrereErgebnis {
  id: string;
  ok: boolean;
  task?: Aufgabe;
  fehler?: { code: string; message: string };
}

export interface MehrereAntwort {
  ergebnisse: MehrereErgebnis[];
  ok: number;
  fehler: number;
}

/** Fällige Erinnerung für das Banner: Aufgabe plus Zeitpunkt, zu dem sie sich meldet */
export interface Erinnerung extends Aufgabe {
  faellig_um: string;
}

/** Anrufaufgabe anlegen: ohne Text entsteht „Anrufen: Name“, ohne Kontakt der erste mit Nummer, ohne Datum heute. */
export interface AnrufAufgabeEingabe extends Omit<AufgabeEingabe, "text"> {
  text?: string;
}

export const inboxApi = {
  liste: (p: InboxParameter = {}, signal?: AbortSignal) =>
    http.get<Liste<Aufgabe>>("/api/tasks", { view: p.view, assigned_to: p.assigned_to, kategorie: p.kategorie, limit: p.limit, cursor: p.cursor }, signal),
  /** Zähler der Reiter für eine Person (me, all, user_…) */
  reiter: (assignedTo = "me") => http.get<ReiterZaehler>("/api/tasks/reiter", { assigned_to: assignedTo }),
  /** Mehrere auf einmal erledigen oder verschieben (Auswahlmodus); jede Aufgabe geht einzeln nach Close */
  mehrere: (ids: string[], aenderung: { is_complete?: boolean; date?: string | null }) =>
    http.post<MehrereAntwort>("/api/tasks/mehrere", { ids, ...aenderung }),
  erinnerungen: () => http.get<{ data: Erinnerung[] }>("/api/tasks/erinnerungen"),
  /** Banner bestätigt (erscheint nicht wieder, auch nicht nach Neuladen) */
  gesehen: (taskId: string) => http.post<void>(`/api/tasks/erinnerungen/${k(taskId)}/gesehen`),
  /** Banner „Später“: in 10 Minuten wieder erinnern (die Aufgabe bleibt unverändert) */
  spaeter: (taskId: string) => http.post<void>(`/api/tasks/erinnerungen/${k(taskId)}/spaeter`),
  anrufAnlegen: (e: AnrufAufgabeEingabe) => http.post<{ task: Aufgabe }>("/api/tasks", { ...e, typ: "outgoing_call" }),
};
